import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/internal-genesis/page.tsx");
